<span class="badge" [class.violet]="variant === 'violet'" [class.green]="variant === 'green'" [class.amber]="variant === 'amber'">
  <ng-content></ng-content>
</span>
